import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-servicios-empresas',
  templateUrl: './servicios-empresas.component.html',
  styleUrls: ['./servicios-empresas.component.css']
})
export class ServiciosEmpresasComponent implements OnInit {

  // Tab activo
  tabActivo = 0;

  // Servicios principales con tabs
  servicios = [
    {
      id: 'mapeo',
      titulo: 'Mapeo de Talento',
      icono: 'fas fa-search',
      entregables: [
        'Base de datos propia segmentada por región, competencias y experiencia',
        'Mapeo de mercado especializado en tu sector',
        'Reporte de disponibilidad y expectativas salariales',
        'Perfiles pre-evaluados y certificados'
      ],
      sla: '72 horas para perfiles iniciales',
      kpis: [
        '95% de perfiles verificados',
        'Cobertura del 80% del territorio nacional',
        'Actualización semanal de disponibilidad'
      ]
    },
    {
      id: 'formacion',
      titulo: 'Formación Acelerada',
      icono: 'fas fa-graduation-cap',
      entregables: [
        'Rutas formativas personalizadas por rol',
        'Alianzas con SENA, universidades y bootcamps',
        'Modalidad híbrida (presencial + virtual)',
        'Certificaciones reconocidas por el sector'
      ],
      sla: '4-8 semanas según complejidad',
      kpis: [
        '90% de aprobación en certificaciones',
        'Reducción del 60% en tiempo de formación',
        'Alianzas con 15+ instituciones educativas'
      ]
    },
    {
      id: 'rediseno',
      titulo: 'Rediseño de Puestos',
      icono: 'fas fa-tools',
      entregables: [
        'Diagnóstico de barreras físicas y tecnológicas',
        'Adaptaciones tecnológicas y metodológicas',
        'Modelos flexibles y remotos',
        'Documentación completa del puesto'
      ],
      sla: '2-4 semanas por puesto',
      kpis: [
        '100% de puestos adaptados',
        'Reducción del 70% en barreras',
        'Documentación accesible al 100%'
      ]
    },
    {
      id: 'cultura',
      titulo: 'Cultura & Métricas',
      icono: 'fas fa-users',
      entregables: [
        'Talleres de liderazgo inclusivo',
        'Plan de transformación 6-12 meses',
        'Medición de eNPS y satisfacción',
        'Programas de retención y desarrollo'
      ],
      sla: '6-12 meses para transformación completa',
      kpis: [
        'Mejora del 40% en eNPS',
        'Reducción del 50% en rotación',
        '95% de líderes capacitados'
      ]
    }
  ];

  // Tabla comparativa
  comparacion = [
    {
      aspecto: 'Alcance',
      solo: 'Limitado a búsqueda básica',
      inclutec: 'End-to-end con acompañamiento'
    },
    {
      aspecto: 'Especialización',
      solo: 'Generalista, sin expertise en discapacidad',
      inclutec: 'Especialistas certificados en inclusión'
    },
    {
      aspecto: 'Base de datos',
      solo: 'Dependiente de portales públicos',
      inclutec: 'Base propia verificada y segmentada'
    },
    {
      aspecto: 'Formación',
      solo: 'No incluye desarrollo de competencias',
      inclutec: 'Rutas formativas personalizadas'
    },
    {
      aspecto: 'Adaptación',
      solo: 'Sin ajustes razonables',
      inclutec: 'Rediseño completo de puestos'
    },
    {
      aspecto: 'Medición',
      solo: 'Sin métricas de impacto',
      inclutec: 'Dashboard completo de KPIs'
    }
  ];

  // Paquetes/Bundles
  paquetes = [
    {
      nombre: 'Express 50-99',
      descripcion: 'Solución rápida para empresas pequeñas',
      precio: 'Desde $2.5M',
      cohortes: '1-2 personas',
      metricas: [
        'Cumplimiento legal garantizado',
        'Tiempo de cobertura: 4-6 semanas',
        'Soporte por 3 meses'
      ],
      destacado: false
    },
    {
      nombre: 'Estándar 100-500',
      descripcion: 'Solución completa para empresas medianas',
      precio: 'Desde $5M',
      cohortes: '2-10 personas',
      metricas: [
        'Cumplimiento + métricas de impacto',
        'Tiempo de cobertura: 3-6 meses',
        'Soporte por 6 meses + seguimiento'
      ],
      destacado: true
    },
    {
      nombre: 'Corporativo 500+',
      descripcion: 'Transformación cultural completa',
      precio: 'Personalizado',
      cohortes: '10+ personas',
      metricas: [
        'Transformación cultural + cumplimiento',
        'Tiempo: 6-12 meses',
        'Soporte continuo + consultoría'
      ],
      destacado: false
    }
  ];

  // Casos de éxito
  casosExito = [
    {
      empresa: 'TechCorp Colombia',
      sector: 'Tecnología',
      empleados: 150,
      reto: 'Cumplir Ley 2466 en sector altamente técnico',
      solucion: 'Mapeo + formación acelerada en desarrollo',
      resultados: {
        cumplimiento: '100%',
        productividad: '+25%',
        retencion: '95% a 6 meses'
      }
    },
    {
      empresa: 'Grupo Empresarial',
      sector: 'Servicios',
      empleados: 300,
      reto: 'Transformar cultura para inclusión',
      solucion: 'Rediseño + cultura inclusiva',
      resultados: {
        cumplimiento: '100%',
        productividad: '+18%',
        retencion: '92% a 6 meses'
      }
    }
  ];

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  // Métodos para funcionalidad
  cambiarTab(index: number): void {
    this.tabActivo = index;
  }

  agendarDiagnostico(): void {
    console.log('Redirigiendo a contacto para agendar diagnóstico');
    this.router.navigate(['/contacto']);
  }



  contactarVentas(): void {
    console.log('Redirigiendo a contacto para ventas');
    this.router.navigate(['/contacto']);
  }
}
